export default "/25f710847dd0be805cb8ee54d4e27cd8317d2a0f/decc719ac0c1523cc2040d71b927dcbc.svg";